<div class="card card-grey card-form subscriptions-card">

  <div class="navigation">
    <div class="navigation-item-wrapper" [class.active]="isActive('subscriptions')" (click)="onTab('subscriptions')">
      <span class="navigation-item-label">Votre abonnement & options</span>
    </div>
    <div class="navigation-item-wrapper" [class.active]="isActive('invoices')" (click)="onTab('invoices')">
      <span class="navigation-item-label">Vos factures</span>
    </div>
    <div class="navigation-item-wrapper" [class.active]="isActive('card')" (click)="onTab('card')">
      <span class="navigation-item-label">Votre mode de paiement & avoirs</span>
    </div>
  </div>

  <div class="tab-content">
    <!-- Subscriptions -->
    <ng-container *ngIf="isActive('subscriptions')">
      <!-- Showcase Subscriptions -->
      <ng-container *ngIf="!loadingSubscription && (!isAlreadySubscribed || isTrialing); else loadingShowcase">
        <div class="subscriptions-wrapper">
          <div class="subscriptions-showcase-wrapper">
            <msd-premium-card *ngIf="!isIssuedPayment" (onChoose)="subscribe($event)"
                              [loading]="loadingSubscription || loadingSubscriptionAction">
            </msd-premium-card>
            <msd-unpaid-card (modify)="modifyPaymentInformation()"
                             (pay)="payInvoice()"
                             *ngIf="isIssuedPayment"
                             [latestSubscription]="latestSubscription?.subscription"
                             [loading]="loadingUpdatePaymentMethod"
                             [loadingInvoice]="loadingInvoices">
            </msd-unpaid-card>
          </div>
          <ngx-inner-loading *ngIf="loadingSubscriptionAction"
                             class="flex-center"
                             [loading]="loadingSubscriptionAction"
                             [loadingDescription]="'Veuillez patienter...'">
          </ngx-inner-loading>
        </div>
      </ng-container>
      <ng-template #loadingShowcase>
        <ngx-inner-loading *ngIf="loadingSubscription"
                           [loadingDescription]="'Chargement des souscriptions...'"
                           [loading]="true"
                           class="flex-center">
        </ngx-inner-loading>
      </ng-template>

      <!-- Subscription & features -->
      <ng-container *ngIf="isAlreadySubscribed && !isTrialing else loadingSubscriptionAndFeatures">
        <div class="subscriptions-wrapper">
          <div *ngIf="!errorSubscription && !loadingSubscription; else innerSubLoading"
               class="subscriptions-data-wrapper">
            <div class="already-subscriber-wrapper">
              <div
                *ngIf="latestSubscription && latestSubscription.subscription && latestSubscription.subscription.periodEnd > now"
                class="card card-grey card-form">
                <h3 class="subtitle-wrapper">Votre abonnement</h3>
                <div class="subscription-premium">
                  <div class="icon">
                    <i i-bs [name]="getIconPremium(latestSubscription.prices)" width="40" height="40"></i>
                  </div>
                  <div class="content">
                    <div class="premium-name">Abonnement
                      Premium {{ getSubscriptionPeriod(latestSubscription.prices) }}
                    </div>
                    <div class="premium-info" *ngIf="latestSubscription?.subscription?.isCancellable">
                      Votre abonnement se renouvellera le {{ endPeriodFormattedDate }}.
                    </div>
                    <div class="premium-info" *ngIf="latestSubscription?.subscription?.isPendingCancellation">
                      L'abonnement a bien été annulé, il ne sera pas renouvelé automatiquement. Le service reste
                      accessible jusqu'au {{ endPeriodFormattedDate }}.
                    </div>
                    <div class="premium-description" *ngIf="latestSubscription?.subscription?.isCancellable">
                      Abonnement en cours, avec renouvellement automatique...
                    </div>
                  </div>
                  <div class="subscription-button">
                    <button
                      *ngIf="latestSubscription?.subscription?.isCancellable && isMonthly(latestSubscription.prices)"
                      (click)="updatePremium(latestSubscription, isMonthly(latestSubscription.prices))"
                      class="btn btn-gradient btn-subscribe mb5px"
                      [disabled]="loadingSubscriptionAction">
                      <ng-container *ngIf="changeSubscriptionInProgress; else changeSubscriptionButtonTemplate">
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        <span class="visually-hidden">Chargement...</span>
                      </ng-container>
                      <ng-template #changeSubscriptionButtonTemplate>
                        Passer à la formule annuelle
                      </ng-template>
                    </button>
                    <button *ngIf="latestSubscription?.subscription?.isCancellable"
                            class="btn btn-gradient btn-danger"
                            [disabled]="loadingSubscriptionAction"
                            (click)="confirmUnsubscribe()">
                      <ng-container *ngIf="cancelSubscriptionInProgress; else cancelSubscriptionButtonTemplate">
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        <span class="visually-hidden">Chargement...</span>
                      </ng-container>
                      <ng-template #cancelSubscriptionButtonTemplate>
                        Annuler mon abonnement
                      </ng-template>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-template #innerSubLoading>
            <ngx-inner-loading class="flex-center" [error]="!!errorSubscription" [loading]="loadingSubscription"
                               (retry)="loadSubscription(this.dietitian)"
                               [loadingDescription]="'Chargement souscription...'"
                               [emptyDescription]="'Aucune souscription ...'"
                               [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'"
                               [retryButtonText]="'Réessayer'">
            </ngx-inner-loading>
          </ng-template>
        </div>
        <div *ngIf="!errorFeatures && !loadingFeatures; else innerFeatLoading"
             class="subscription-feature-wrapper">
          <div class="subscription-feature-data-wrapper">
            <div class="card card-grey card-form card-subscription-feature">
              <h3 class="subtitle-wrapper">Vos options</h3>
              <div *ngFor="let model of featureModels" class="subscription-feature">
                <div class="icon"
                     [style]="'background-color: ' + (model.stripeProduct?.backgroundColor ?? 'rgba(95, 120, 255, 0.15)') + '; color: ' + (model.stripeProduct?.color ?? 'rgba(95, 120, 255, 0.25)') + ';'">
                  <i i-bs [name]="getIcon(model.stripeProduct?.icon ?? undefined)" width="30" height="30"></i>
                </div>
                <div class="content">
                  <div class="feature-name" *ngIf="!model.subscription">
                    {{ model.stripeProduct?.name }}{{ !latestSubscription?.subscription?.isCancellable ? ' - Un abonnement Premium est requis !' : '' }}
                  </div>
                  <div class="feature-name" *ngIf="model.subscription">
                    {{ model.stripeProduct?.name }}
                  </div>
                  <div class="feature-price" *ngIf="!model.subscription">
                    {{ getPrice(model.stripeProduct) }}
                  </div>
                  <div class="feature-price"
                       *ngIf="model.subscription && (model.subscription.isIncomplete || model.subscription.isPastDue)">
                    Le paiement est incomplet, une action est requise. Veuillez cliquer sur le bouton et suivre les
                    instructions. Ces actions auront lieu dans un onglet différent, depuis nos serveurs bancaires...
                  </div>
                  <div class="feature-price" *ngIf="model.subscription && model.subscription.isCancellable">
                    Votre abonnement se renouvellera le {{ formattedDate(model.subscription.periodEnd) }}.
                  </div>
                  <div class="feature-price" *ngIf="model.subscription && model.subscription.isPendingCancellation">
                    L'abonnement a bien été annulé, il ne sera pas renouvelé automatiquement. Le service reste
                    accessible jusqu'au {{ formattedDate(model.subscription.periodEnd) }}.
                  </div>
                  <div class="feature-description" *ngIf="!model.subscription">
                    {{ model.stripeProduct?.description }}
                  </div>
                  <div class="feature-description" *ngIf="model.subscription && model.subscription.isCancellable">
                    Abonnement en cours, avec renouvellement automatique...
                  </div>
                </div>
                <div class="action">
                  <div *ngIf="!model.subscription">
                    <button (click)="subscribeFeature(model)"
                            *ngIf="latestSubscription?.subscription?.isCancellable"
                            [disabled]="loadingSubscriptionAction"
                            class="btn btn-gradient btn-subscribe">
                      <ng-container *ngIf="!model.isLoading else loader">
                        S'abonner
                      </ng-container>
                      <ng-template #loader>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        <span class="visually-hidden">Chargement...</span>
                      </ng-template>
                    </button>
                  </div>
                  <div
                    *ngIf="model.subscription && (model.subscription.isIncomplete || model.subscription.isPastDue)">
                    <button (click)="completeSubscribeFeature(model)"
                            [disabled]="loadingSubscriptionAction"
                            class="btn btn-gradient btn-warning">
                      <ng-container *ngIf="!model.isLoading else loader">
                        Compléter mon règlement
                      </ng-container>
                      <ng-template #loader>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        <span class="visually-hidden">Chargement...</span>
                      </ng-template>
                    </button>
                  </div>
                  <div *ngIf="model.subscription && model.subscription.isActive">
                    <button (click)="unsubscribeFeature(model)"
                            *ngIf="model.subscription.isCancellable"
                            [disabled]="loadingSubscriptionAction"
                            class="btn btn-gradient btn-danger">
                      <ng-container *ngIf="!model.isLoading else loader">
                        Annuler mon abonnement
                      </ng-container>
                      <ng-template #loader>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        <span class="visually-hidden">Chargement...</span>
                      </ng-template>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #innerFeatLoading>
          <ngx-inner-loading class="flex-center" [error]="!!errorFeatures" [loading]="loadingFeatures"
                             (retry)="loadFeatures(this.dietitian)"
                             [loadingDescription]="'Chargement options...'"
                             [emptyDescription]="'Aucune option ...'"
                             [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'"
                             [retryButtonText]="'Réessayer'">
          </ngx-inner-loading>
        </ng-template>
      </ng-container>
      <ng-template #loadingSubscriptionAndFeatures>
        <ngx-inner-loading *ngIf="!errorSubscription && isAlreadySubscribed && !isTrialing" class="flex-center"
                           [loading]="true"
                           [loadingDescription]="'Veuillez patienter pendant le chargement des Premiums et options...'">
        </ngx-inner-loading>
      </ng-template>
    </ng-container>

    <!-- Invoices -->
    <ng-container *ngIf="isActive('invoices')">
      <div class="invoices-wrapper">
        <div class="invoices-list-wrapper">
          <h3 class="subtitle-wrapper">Vos factures</h3>
          <table *ngIf="!errorInvoices && !loadingInvoices && invoices && invoices.length > 0 else innerLoadingInvoices"
                 class="table invoices-table">
            <thead>
            <tr class="invoice-header">
              <th scope="col" class="identifier-col">Numéro</th>
              <th scope="col" class="date-col">Date</th>
              <th scope="col" class="status-col">Status</th>
              <th scope="col" class="amount-col">Montant</th>
              <th scope="col" class="attachment-col">Pdf</th>
            </tr>
            </thead>
            <tbody>
            <tr (downloadPdf)="downloadPdf($event)"
                (payInvoice)="payInvoice()"
                *ngFor="let invoice of invoices; let isLast = last; let idx = index"
                [invoice]="invoice"
                [isLast]="isLast"
                [id]="'invoice_' + idx"
                class="invoice-row"
                msd-invoice-cell>
            </tr>
            </tbody>
          </table>
          <ng-template #innerLoadingInvoices>
            <ngx-inner-loading (retry)="loadInvoices()"
                               [emptyDescription]="'Aucune facture ...'"
                               [empty]="!invoices || invoices.length === 0"
                               [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'"
                               [error]="!!errorInvoices"
                               [loadingDescription]="'Chargement factures...'"
                               [loading]="loadingInvoices"
                               [retryButtonText]="'Réessayer'"
                               class="flex-center">
            </ngx-inner-loading>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- Card & Balances -->
    <ng-container *ngIf="isActive('card')">
      <div class="card-wrapper">
        <h3 class="subtitle-wrapper">Votre mode de paiement</h3>
        <ng-container
          *ngIf="!loadingPaymentMethods && !errorPaymentMethods && paymentMethods && paymentMethods.length > 0 else innerLoadingCard">
          <msd-payment-informations-edit
            *ngFor="let paymentMethod of paymentMethods"
            (modify)="modifyPaymentInformation()"
            (default)="defaultPaymentMethod(paymentMethod)"
            [withModifyButton]="!!latestSubscription && !!latestSubscription.subscription
            && (latestSubscription.subscription.isCancellable || latestSubscription.subscription.periodEnd < now)"
            [paymentMethod]="paymentMethod"
            [loading]="loadingUpdatePaymentMethod">
          </msd-payment-informations-edit>
        </ng-container>
        <ng-template #innerLoadingCard>
          <ngx-inner-loading [emptyDescription]="'Aucun mode de paiement...'"
                             [empty]="!paymentMethods || paymentMethods.length === 0"
                             [loading]="loadingPaymentMethods"
                             [loadingDescription]="'Chargement de votre mode de paiement'"
                             [error]="!!errorPaymentMethods"
                             [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'"
                             class="flex-center" style="height: 120px">
          </ngx-inner-loading>
        </ng-template>
      </div>

      <div class="balances-list-wrapper mt2em">
        <h3 class="subtitle-wrapper">Vos avoirs</h3>
        <table *ngIf="!loadingBalances && balances && balances.length > 0 else innerLoadingBalances"
               class="table balances-table">
          <thead>
          <tr class="balance-header">
            <th scope="col" class="balance-reason-col">Motif</th>
            <th scope="col" class="balance-invoice-col">Facture</th>
            <th scope="col" class="balance-date-col">Date</th>
            <th scope="col" class="balance-debit-col">Débit</th>
            <th scope="col" class="balance-credit-col">Crédit</th>
            <th scope="col" class="balance-col">Solde</th>
          </tr>
          </thead>
          <tbody>
          <tr (downloadPdf)="downloadPdf($event)"
              *ngFor="let balance of balances; let isLast = last; let idx = index"
              [balance]="balance"
              [id]="'balance_' + idx"
              [isLast]="isLast"
              class="invoice-row"
              msd-balance-row>
          </tr>
          </tbody>
        </table>
        <ng-template #innerLoadingBalances>
          <ngx-inner-loading (retry)="loadBalances()"
                             [emptyDescription]="'Aucune ligne d\'avoir ...'"
                             [empty]="!balances || balances.length === 0"
                             [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'"
                             [error]="!!errorBalances"
                             [loadingDescription]="'Chargement avoirs...'"
                             [loading]="loadingBalances"
                             [retryButtonText]="'Réessayer'"
                             class="flex-center">
          </ngx-inner-loading>
        </ng-template>
      </div>
    </ng-container>
  </div>
</div>



